import MonthlyGenerationDownload from './MonthlyGenerationDownload'

export default MonthlyGenerationDownload
